import { render, staticRenderFns } from "./UltimasActualizaciones.vue?vue&type=template&id=5c2984dc&"
import script from "./UltimasActualizaciones.vue?vue&type=script&lang=js&"
export * from "./UltimasActualizaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports